module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marcel Theroux\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Marcel Theroux")]), _vm._v(" is the author of several novels, including "), _c('I', [_vm._v("Far North")]), _vm._v(", which was a finalist for the National Book Award and the Arthur C. Clarke Award for science fiction. He lives in London, where he also works as a documentary filmmaker and television presenter.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QVvclJ/tc-custom/9780374709518.jpg?1719374605895",
      "alt": "This image is the cover for the book Strange Bodies"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Strange Bodies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A dizzying novel of deception and metempsychosis by the author of the National Book Award finalist ")]), _c('i', [_c('b', [_vm._v("Far North"), _c('br'), _c('br')])]), _c('br'), _c('br'), _c('i', [_vm._v("Whatever this is, it started when Nicholas Slopen came back from the dead."), _c('br'), _c('br')]), _vm._v("In a locked ward of a notorious psychiatric hospital sits a man who insists that he is Dr. Nicholas Slopen, failed husband and impoverished Samuel Johnson scholar. Slopen has been dead for months, yet nothing can make this man change his story. What begins as a tale of apparent forgery involving unknown letters by the great Dr. Johnson grows to encompass a conspiracy between a Silicon Valley mogul and his Russian allies to exploit the darkest secret of Soviet technology: the Malevin Procedure."), _c('br'), _vm._v(" Marcel Theroux's "), _c('i', [_vm._v("Strange Bodies")]), _vm._v(" takes the reader on a dizzying speculative journey that poses questions about identity, authenticity, and what it means to be truly human.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0